<template>
    <div 
        class="modal fade"
        id="addProjectModal"
        tabindex="-1"
        aria-labelledby="addProject"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addProject">
                        {{isEdit ? 'Edit' : 'Add'}} Project
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <form @submit.prevent="submit">
                <div class="modal-body">

                    <div class="row">

                        <div class="col-md-9 text-start mt-2">
                            <label for="project_name" class="form-label">Project Name:</label>
                            <div class="input-group has-validation">
                                <input type="text" :class="{'form-control':true, 'is-invalid':errors.project_name ? true : false}" id="project_name" v-model="form.project_name" autofocus aria-describedby="nameFeedback" required>
                                <div v-if="errors.project_name" id="nameFeedback" class="invalid-feedback">
                                    {{errors.project_name}}
                                </div>
                            </div>
                        </div>
                    

                        <div class="col-md-3 text-start mt-2">
                            <label for="project_id" class="form-label">Project ID:</label>
                            <div class="input-group has-validation">
                                <input type="text" :class="{'form-control':true, 'is-invalid':errors.project_id ? true : false}" id="project_id" v-model="form.project_id" autofocus aria-describedby="nameFeedback" required>
                                <div v-if="errors.project_id" id="nameFeedback" class="invalid-feedback">
                                    {{errors.project_id}}
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="row">

                        <div class="col-md-4 text-start mt-2 col-md-push-4">
                            <label for="customer_id" class="form-label">Customer:</label>
                            <div class="input-group has-validation">
                                <select :class="{'form-select':true, 'is-invalid':errors.customer_id ? true : false}" id="customer_id" v-model="form.customer_id" required>
                                    <option v-for="customer in customers" :key="customer.id" :value="customer.id">{{ customer.company_name }}</option>
                                </select>
                                <div  v-if="errors.customer_id" id="phoneFeedback" class="invalid-feedback">
                                    {{errors.customer_id}}
                                </div>
                            </div>
                        </div>  

                        <div class="col-md-4 text-start mt-2">
                            <label for="type" class="form-label">Project Type:</label>
                            <div class="input-group has-validation">
                                <select :class="{'form-select':true, 'is-invalid':errors.type ? true : false}" id="type" v-model="form.type" required>
                                    <option value="test">Test</option>
                                </select>
                                <div  v-if="errors.type" id="phoneFeedback" class="invalid-feedback">
                                    {{errors.type}}
                                </div>
                            </div>
                        </div>  

                    </div>

                    <div class="row">

                        <div class="col-md-4 text-start mt-2">
                            <label for="owner_id" class="form-label">Owner:</label>
                            <div class="input-group has-validation">
                                <select :class="{'form-select':true, 'is-invalid':errors.owner_id ? true : false}" id="owner_id" v-model="form.owner_id" required>
                                    <option v-for="user in users" :key="user.id" :value="user.id">{{ user.name }}</option>
                                </select>
                                <div  v-if="errors.owner_id" id="phoneFeedback" class="invalid-feedback">
                                    {{errors.owner_id}}
                                </div>
                            </div>
                        </div>   

                        <div class="col-md-4 text-start mt-2">
                            <label for="lead_id" class="form-label">Lead:</label>
                            <div class="input-group has-validation">
                                <select :class="{'form-select':true, 'is-invalid':errors.lead_id ? true : false}" id="lead_id" v-model="form.lead_id" required>
                                    <option v-for="user in users" :key="user.id" :value="user.id">{{ user.name }}</option>
                                </select>
                                <div  v-if="errors.lead_id" id="phoneFeedback" class="invalid-feedback">
                                    {{errors.lead_id}}
                                </div>
                            </div>
                        </div> 

                    </div>
                    <div class="row">

                        <div class="col-md-3 text-start mt-2">
                            <label for="turnover" class="form-label">Est. Revenue:</label>
                            <div class="input-group has-validation">
                                <input type="text" :class="{'form-control':true, 'is-invalid':errors.turnover ? true : false}" id="turnover" v-model="form.turnover" autofocus aria-describedby="nameFeedback" required>
                                <div v-if="errors.turnover" id="nameFeedback" class="invalid-feedback">
                                    {{errors.turnover}}
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3 text-start mt-2">
                            <label for="days" class="form-label">Est. effort in mandays:</label>
                            <div class="input-group has-validation">
                                <input type="text" :class="{'form-control':true, 'is-invalid':errors.days ? true : false}" id="days" v-model="form.days" autofocus aria-describedby="nameFeedback" required>
                                <div v-if="errors.days" id="nameFeedback" class="invalid-feedback">
                                    {{errors.days}}
                                </div>
                            </div>
                        </div> 

                        
                    </div>
                    <div class="row">

                        <div class="col-md-3 text-start mt-2">

                            <div class="mb-3 position-relative" id="datepicker1">
                                <label class="form-label">Start Date</label>
                                <input type="date" v-model="form.start_date" class="form-control" autofocus aria-describedby="startDateFeedback" :class="{'form-control':true, 'is-invalid':errors.start_date ? true : false}" required data-provide="datepicker" data-date-container="#start_date" data-date-format="d-M-yyyy" data-date-autoclose="true">
                                <div v-if="errors.start_date" id="startDateFeedback" class="invalid-feedback">
                                    {{errors.start_date}}
                                </div>
                            </div>

                        </div> 

                        <div class="col-md-3 text-start mt-2">

                            <div class="mb-3 position-relative" id="datepicker1">
                                <label class="form-label">End Date</label>
                                <input type="date" v-model="form.end_date" class="form-control" autofocus aria-describedby="endDateFeedback" :class="{'form-control':true, 'is-invalid':errors.end_date ? true : false}" required data-provide="datepicker" data-date-container="#end_date" data-date-format="d-M-yyyy" data-date-autoclose="true">
                                <div v-if="errors.end_date" id="endDateFeedback" class="invalid-feedback">
                                    {{errors.end_date}}
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="row">

                        <div class="col-md-3 text-start mt-2">
                            <div class="form-check">
                                <input
                                type="checkbox"
                                class="form-check-input"
                                id="checkbox-cancelled"
                                value="cancelled"
                                :checked="form.cancelled"
                                v-model="form.cancelled">
                                <label class="form-check-label" for="checkbox-cancelled">Canceled</label>
                            </div>
                        </div>    

                        <div class="col-md-3 text-start mt-2">
                            <div class="form-check">
                                <input
                                type="checkbox"
                                class="form-check-input"
                                id="checkbox-archived"
                                value="archived"
                                :checked="form.archived"
                                v-model="form.archived">
                                <label class="form-check-label" for="checkbox-archived">Archived</label>
                            </div>
                        </div>    

                        <div class="col-md-3 text-start mt-2">
                            <div class="form-check">
                                <input
                                type="checkbox"
                                class="form-check-input"
                                id="checkbox-billed"
                                value="billed"
                                :checked="form.billed"
                                v-model="form.billed">
                                <label class="form-check-label" for="checkbox-billed">Billable</label>
                            </div>
                        </div>
                        
                    </div> 


                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                    >
                        Cancel
                    </button>
                    <button type="submit" class="btn btn-primary" :disabled="form.processing">
                        {{isEdit ? 'Update' : 'Save'}}
                    </button>
                </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap';

export default {
    props: {
        project: Object,
        users: Array,
        customers: Array,
        isEdit: Boolean
    },
    data() {
        return {
            modal: null,
            form: this.$inertia.form({
                project_name: this.project ? this.project.project_name : "" ,
                project_id: this.project ? this.project.project_id : "",
                owner_id: this.project ? this.project.owner_id : "" ,
                lead_id: this.project ? this.project.lead_id : "",
                customer_id: this.project ? this.project.customer_id : "" ,
                cancelled: this.project ? this.project.cancelled : "",
                archived: this.project ? this.project.archived : "" ,
                billed: this.project ? this.project.billed : "",
                type: this.project ? this.project.type : "" ,
                turnover: this.project ? this.project.turnover : "",
                effort: this.project ? this.project.effort : "" ,
                start_date: this.project ? this.project.start_date : "",
                end_date: this.project ? this.project.end_date : "" ,
                days: this.project ? this.project.days : "",
                stage: this.project ? this.project.stage : "" 
            }),
            errors: {
                project_name: null,
                project_id: null,
                owner_id: null,
                lead_id: null,
                customer_id: null,
                cancelled: null,
                archived: null,
                billed: null,
                type: null,
                turnover: null,
                effort: null,
                start_date: null,
                end_date: null,
                days: null,
                stage: null,
            },
        };
    },
    mounted() {
        var modalEl = document.getElementById('addProjectModal')
        this.modal = new Modal(modalEl)
        this.modal.show();
        
        modalEl.addEventListener('hidden.bs.modal',  (event) => {
            this.$emit('modelStatusChanged',false)
        })
    },
    methods: {
        close(){
            //this.isOpen = false
        },
        submit() {
            let route = this.isEdit ? this.route("projects.update",this.project.id) : this.route("projects.store")
            let method = this.isEdit ? 'patch' : 'post'
            this.form[this.isEdit ?'patch' : 'post'](route, {
                onError: (errors) => {
                    
                    if (Object.entries(errors).length !== 0) {
                        var toast = {
                            bg: "bg-danger",
                        };

                        if (errors.hasOwnProperty("project_name")) {
                            toast.message = errors.project_name;
                            this.errors.project_name = errors.project_name;
                        }

                        if (errors.hasOwnProperty("customer_id")) {
                            toast.message = errors.customer_id;
                            this.errors.customer_id = errors.customer_id;
                        }

                        if (errors.hasOwnProperty("type")) {
                            toast.message = errors.type;
                            this.errors.type = errors.type;
                        }

                        if (errors.hasOwnProperty("start_date")) {
                            toast.message = errors.start_date;
                            this.errors.start_date = errors.start_date;
                        }

                        if (errors.hasOwnProperty("end_date")) {
                            toast.message = errors.end_date;
                            this.errors.end_date = errors.end_date;
                        }
                    }
                }, 
                onSuccess: () => {
                    this.form.reset();
                    this.modal.hide();

                }
            });
        },
    },
};
</script>
